import React from 'react';

import classNames from "classnames";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import styles from "../../styles/athlete-widget.placeholder.module.scss";
import {AthleteWidgetRowPlaceholder} from "./row/athlete-widget.row.placeholder";

export const AthleteWidgetLastMatchesPlaceholder = ({device}) => {
  const {isSmallView} = device;

  return (
    <PlaceholderWrapperComponent className={classNames(styles.last_matches, {[styles.small_view]: isSmallView})}>
      <div className={classNames(styles.last_matches_content, {[styles.small_view]: isSmallView})}>
        <AthleteWidgetRowPlaceholder/>
        <AthleteWidgetRowPlaceholder/>
        <AthleteWidgetRowPlaceholder/>
        <AthleteWidgetRowPlaceholder/>
        <AthleteWidgetRowPlaceholder/>
      </div>
    </PlaceholderWrapperComponent>
  )
};